var env = {
    LOCAL_API_BASE_URL: '//127.0.0.1:80/api',
    LOCAL_API_VERSION: 'v0',
    AUTH0_CLIENT_ID: 'kEIOEF5l3XAwyXxdlKN0xp2fQMfjdy1K',
    AUTH0_DOMAIN: 'clerk-ai.eu.auth0.com',
    AUTH0_LOCK_BRAND_LOGO_URL: '',
    AUTH0_JWT_WHITELISTED_DOMAIN: 'automatedaccounting.io',
    LOGROCKET_PROJECT_REF: '',
    MIXPANEL_PROJECT_TOKEN: '82924121522e1607392f3c3814f42c26',
    INTERCOM_ID: 'ufyaww65',
    INTERCOM_APP_TAG: 'aaio',
    FILESTACK_API_KEY: 'AxD1P2QyRQxONX3VxpWg5z',
    FILESTACK_CREATOR_POLICY: 'eyJjYWxsIjpbInBpY2siLCJzdG9yZSJdLCJleHBpcnkiOjE4MjYxMzMwNDJ9',
    FILESTACK_CREATOR_SIGNATURE: '960c43c420cc2d7c33f1fc37b160e6a6bf933803da43e2f16c2ecd84d6ef2a61',
    OPTIMIZELY_PROJECT_ID: '4974560705',
    FB_CONVERSION_PIXEL_ID: '1155020544575192',
    ADWORDS_CONVERSION_ID: '984886622',
    ADWORDS_CONVERSION_LABEL: 'C9TeCLnamFkQ3trQ1QM',
    GA_TRACKING_ID: 'UA-86528612-1',
    HOTJAR_SITE_ID: '335397',
    OFFLINE_DEV: 'false',
    BRAND_HOME_URL: 'https://clerk.ai',
    BRAND_COMPANY: 'Clerk.AI OÜ',
    SITENAME: 'AutomatedAccounting.IO',
    DEFAULT_PAGE_TITLE: 'AutomatedAccounting.IO | Instantly generated accounting',
    DEFAULT_UI_STATE: 'root.start',
    TERMS_URL: 'https://clerk.ai/legal/terms-of-service/'
};
module.exports = env;



// WEBPACK FOOTER //
// ./app/scripts/env.js